import React from 'react';
import { Typography, Container, Box } from '@mui/material';

const View = () => (
  <Container maxWidth="xl">
    <Box
      sx={{
        py: { desktop: 6.5, mobile: 3.5 },
      }}
    >
      <Typography variant="h2" style={{ marginBottom: '24px' }}>
        New Request
      </Typography>
    </Box>
  </Container>
);

export default View;
